import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { isHiVolumeContractIdFlow } from '@src/utility/createStorage';
import { getCaseSubmissionRawDataBulk } from '@src/middleware/services/priorAuth/priorAuth.service';

const _httpService = new HttpService();
if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}
// Don't set baseURL at module level - let privateAxios interceptor handle it dynamically at request time
// This ensures checkIsInternal() is evaluated when sessionStorage is properly populated

//Prior Authorization - MOCK METHODS
export const getPriorAuthorizationSubmissionDataMock = async (payload: any) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                "Status": "OK",
                "StatusCode": 200,
                "Message": "Successfully Data Retrieved",
                "TimeStamp": "2025-11-01T02:29:27.543+00:00",
                "Data": {
                    "TinCount": 1,
                    "PeriodStart": "2024-11-01",
                    "PeriodEnd": "2025-10-31",
                    "ProviderSysKey": "959",
                    "SubmittedCount": 683,
                    "ApprovedCount": 522,
                    "NotApprovedCount": 69,
                    "PartiallyApprovedCount": 0,
                    "PendingCount": 3,
                    "CancelledCount": 89,
                    "SubmittedPercent": 100,
                    "ApprovedPercent": 76.4,
                    "NotApprovedPercent": 10.1,
                    "PartiallyApprovedPercent": 0,
                    "PendingPercent": 0.4,
                    "CancelledPercent": 13
                }
            });
        }, 1000)
    })
}

//Prior Authorization - ACTUAL API METHODS
export const getPriorAuthorizationSubmissionData = async (payload: any) => {
    try {
        if (isHiVolumeContractIdFlow()) {
            const data = await getCaseSubmissionRawDataBulk(payload);
return { Status: 'OK', Data: data };
        }
        return await _httpService.push('/prior-authorizations/case-submission-details', payload);
    } catch (error) {
        console.error('Error fetching prior auth case submission details:', error);
        return { status: false, error };
    }
};
export const getPriorAuthorizationSubmissionDataByChannelMock = async (payload: any) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                "Status": "OK",
                "StatusCode": 200,
                "Message": "Successfully Data Retrieved",
                "TimeStamp": "2025-11-01T02:29:28.239+00:00",
                "Data": {
                    "ProviderSysKey": 959,
                    "PriorAuthSubmissionCount": 80,
                    "SavingsOppinDollar": 865.4000000000001,
                    "SavingsOppinTime": 29
                }
            });
        }, 1000);
    })
}

export const getPriorAuthorizationSubmissionDataByChannel = async (payload: any) => {
    try {
        const response = await _httpService.push('/prior-authorizations/case-submission-by-channel/', payload);
        return response;
    } catch (error) {
        console.error('Error fetching prior auth submission data by channel:', error);
        return { status: false, error };
    }
};

// service interactions - MOCK METHODS
export const getSmartEditsRepairedResubmittedSharedMock = async (payload: any) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                "Status": "OK",
                "StatusCode": 200,
                "Message": "Successfully Data Retrieved",
                "TimeStamp": "2025-11-01T02:23:06.382+00:00",
                "Data": {
                    "ProviderSysKey": null,
                    "Tin": null,
                    "Lob": null,
                    "PeriodStart": "2024-11-01T00:00",
                    "PeriodEnd": "2025-10-31T23:59:59.999999999",
                    "SmartEditSummaryList": [
                        {
                            "EditType": "Reject",
                            "EditCount": 710,
                            "GreaterThanFiveDays": 0,
                            "FiveDaysOrLess": 0
                        },
                        {
                            "EditType": "Informational",
                            "EditCount": 2643,
                            "GreaterThanFiveDays": 0,
                            "FiveDaysOrLess": 0
                        },
                        {
                            "EditType": "Return",
                            "EditCount": 344,
                            "GreaterThanFiveDays": 159,
                            "FiveDaysOrLess": 24
                        },
                        {
                            "EditType": "All",
                            "EditCount": 3697,
                            "GreaterThanFiveDays": 159,
                            "FiveDaysOrLess": 24
                        }
                    ]
                }
            });
        }, 1000);
    });
};

// service interactions - ACTUAL API METHODS
export const getSmartEditsRepairedResubmittedShared = async (payload: any) => {
    try {
        const response = await _httpService.push('/smart-edits/summary', payload);
        return response;
    } catch (error) {
        console.error('Error fetching smart edits summary:', error);
        return { status: false, error };
    }
};

export const getCallsSummaryDataMock = async (payload: any) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                "Status": "OK",
                "StatusCode": 200,
                "Message": "Successfully Data Retrieved",
                "TimeStamp": "2025-11-01T02:23:05.740+00:00",
                "Data": {
                    "PeriodStart": "2024-11-01T00:00",
                    "PeriodEnd": "2025-10-31T23:59:59.999999999",
                    "ProviderSysKey": 959,
                    "TotalCallVolume": 242,
                    "TotalCallTime": 1978.0166666666667,
                    "AverageTime": 8.17362258953168,
                    "TransferRate": 0.0743801652892562
                }
            });
        }, 1000);
    });
};

export const getCallsSummaryData = async (payload: any) => {
    try {
        const response = await _httpService.push('/calls/summary', payload);
        return response;
    } catch (error) {
        console.error('Error fetching calls summary:', error);
        return { status: false, error };
    }
};

// pcms
export const getPCMSData = async (payload: any) => {
    try {
        const response = await _httpService.push('/pcms-amd/', payload);
        return response;
    } catch (error) {
        console.error('Error fetching PCMS data:', error);
        return { status: false, error };
    }
}

export const getPCMSMasterMetrics = async (requestBody: any) => {
    try {
        const payload = {
            "RequestedJourney": "pcmsFilter",
            "PcmsFilter": requestBody
        };
        const response = await _httpService.push('/standard-search/topfilter', payload);
        return response;
    } catch (error) {
        console.error('Error fetching PCMS master metrics:', error);
        return { status: false, error };
    }
}

// POCA - Point of Care Assist Metrics
// This endpoint calls TWO APIs in parallel: users-info and users-ytd-info
export const getPOCATransactionAndUsersData = async (payload: any) => {
    try {
        const [usersInfoData, usersYtdData] = await Promise.all([
            _httpService.push('poca/users-info/', payload),
            _httpService.push('poca/users-ytd-info/', payload)
        ]);

        return [usersInfoData, usersYtdData];
    } catch (error) {
        console.error('Error fetching POCA transaction and users data:', error);
        return { status: false, error };
    }
}

// Provider Search calls endpoints based on fromMyInsights flag
// When fromMyInsights=true: only call year-till-date (keys[0])
// When fromMyInsights=false: call both year-till-date and monthly (keys[0] and keys[1])
export const getPOCAProviderSearchData = async (payload: any, fromMyInsights: boolean = false) => {
    try {
        if (fromMyInsights) {
            // Only call first endpoint when coming from MyInsights
            const ytdData = await _httpService.push('care-assists-year-till-date-metrics/', payload);
            return [ytdData]; // Return as array to match Angular's structure
        } else {
            // Call both endpoints in parallel for other pages
            const [ytdData, monthlyData] = await Promise.all([
                _httpService.push('care-assists-year-till-date-metrics/', payload),
                _httpService.push('care-assists-monthly-metrics/', payload)
            ]);
            return [ytdData, monthlyData];
        }
    } catch (error) {
        console.error('Error fetching POCA provider search data:', error);
        return { status: false, error };
    }
}

export const getPOCAEncountersOpenGapsData = async (payload: any) => {
    try {
        const response = await _httpService.push('poca/gic-gaps', payload);
        return response;
    } catch (error) {
        console.error('Error fetching POCA encounters open gaps data:', error);
        return { status: false, error };
    }
}

export const getPOCAActivatedTinsData = async (payload: any) => {
    try {
        // Using pocaaActivatedTins2 endpoint for service activation check
        const response = await _httpService.push('care-assists-active-tins/', payload);
        return response;
    } catch (error) {
        console.error('Error fetching POCA activated tins data:', error);
        return { status: false, error };
    }
}

// Main POCA data aggregator - handles all 4 API calls
export const getPOCAData = async (payloads: any) => {
    try {
        const { payloadPA, payloadPS, payloadQC, payloadSA, fromMyInsights } = payloads;

        // Call all APIs in parallel
        const apiCalls = [
            getPOCATransactionAndUsersData(payloadPA),
            getPOCAProviderSearchData(payloadPS, fromMyInsights), // Pass flag to control endpoints
            getPOCAEncountersOpenGapsData(payloadQC)
        ];

        // Only add activated tins call if NOT from MyInsights
        if (!fromMyInsights) {
            apiCalls.push(getPOCAActivatedTinsData(payloadSA));
        }

        const responses = await Promise.all(apiCalls);

        // Return all responses for processing in saga
        return {
            Status: 'OK',
            Data: responses,
            fromMyInsights
        };
    } catch (error) {
        console.error('Error fetching POCA data:', error);
        return { status: false, error };
    }
}